export default __webpack_public_path__ + "static/media/3_goole_hotel_ads.ba26b139.svg";